export default __webpack_public_path__ + "static/media/intro.1278820e.gif";